


































































import { Mixins, Component, Prop, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import MixinAncesstors from 'src/components/presenter/item/MixinAncesstors'
import icon from 'src/components/presenter/item/ItemIcon'
import { Dialog, QPullToRefresh } from 'quasar'
import ModalDialog from 'components/modals/Dialog.vue'
import PullAndScroll from 'components/PullAndScroll.vue'
import api from 'src/assets/api/gql'
import ItemGet from 'src/graphql/item/ItemGet.gql'
import ItemChildrenTypeFiltered from 'src/graphql/item/ItemChildrenTypeFiltered.gql'
import { Item, ItemType } from 'src/graphql/types'

@Component({
  components: {
    ModalDialog,
    PullAndScroll
  }
})
export default class ItemParentSelect extends Mixins(MixinAncesstors) {
  icon = icon
  me = store.state.person
  loading: number | null = null
  items: Item[] = []
  itemsCursor: string | null = null

  @Prop()
  readonly title!: string

  @Prop()
  readonly message!: string

  @Prop()
  readonly item!: Item

  @Prop()
  readonly type!: ItemType

  @Ref()
  readonly dialog!: ModalDialog

  async created () {
    const parentId = this.item.path.split('.').slice(0, -1).pop()
    await this.select(parentId ? +parentId : null)
  }

  show () { this.dialog.show() }
  hide () { this.dialog.hide() }

  action (name: string) {
    if (name === 'left') {
      this.dialog.hide()
    } else {
      this.$emit('ok', this.pathItem?.id || null)
    }
  }

  async select (id: number | null) {
    this.loading = id || 0
    if (id) {
      const { data } = await api.query({
        query: ItemGet,
        variables: { id }
      })
      this.pathItem = data.item || null
    } else {
      this.pathItem = null
    }
    this.$nextTick(() => {
      this.loading = null
    })
  }

  async refresh (done: () => void) {
    this.items = []
    this.itemsCursor = null
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    const { data } = await api.query({
      query: ItemChildrenTypeFiltered,
      variables: {
        id: this.pathItem?.id || 0,
        type: this.type,
        after: this.itemsCursor
      }
    })
    if (data.itemChildren) {
      this.items.push(...data.itemChildren.nodes as Item[])
      this.itemsCursor = data.itemChildren.pageInfo.hasNextPage ? data.itemChildren.pageInfo.endCursor : null
    }
    done(!this.itemsCursor)
  }
}

export async function select (parent: Vue, props = {}): Promise<number | null> {
  return new Promise((resolve, reject) => {
    const dialog = Dialog.create({
      parent,
      component: ItemParentSelect,
      ...props
    }).onOk((parentId: number | null) => {
      resolve(parentId)
      dialog.hide()
    })
  })
}
